/**
 * Sidebar geometry shared by every element that has to offset itself around the
 * calendar sidebar.
 *
 * Week view scrolls the *document* horizontally (CalendarLayout's wrapper is
 * `min-width: fit-content`, and WeekView drives scrolling through
 * `document.documentElement.scrollLeft` / `window.scrollBy`). Anything that must
 * stay put while the page slides is therefore `position: fixed`, which takes it
 * out of flow — so its left edge can't simply follow the sidebar and has to be
 * computed from these widths instead.
 *
 * These numbers used to be copy-pasted as bare literals across WeekView,
 * WeekViewDayToggleFooter and ProgramLibraryFooter, which is why changing the
 * sidebar width meant hunting down 384 and 300 in three files.
 */

/** width of the icon rail (IconSideBar) */
export const ICON_RAIL_WIDTH = 48;

/** open width of AnimatedSideBarPrimary, per breakpoint */
export const SIDEBAR_WIDTH_DESKTOP = 384;
export const SIDEBAR_WIDTH_TABLET = 300;

/** AnimatedSideBarPrimary narrows to the tablet width at or below this */
export const SIDEBAR_TABLET_BREAKPOINT = 1023;

/**
 * At or below this the rail is hidden behind the header hamburger and the
 * sidebar opens as a drawer, so neither reserves layout space.
 */
export const SIDEBAR_DRAWER_BREAKPOINT = 767;

/**
 * Space the sidebar reserves to the left of week view's fixed chrome.
 * Mirrors the desktop/tablet rules above; callers add their own
 * `SIDEBAR_DRAWER_BREAKPOINT` media block for the drawer case, where the
 * answer is always 0.
 */
export const getSideBarOffset = (isOpen, isTablet = false) => {
  const openWidth = isTablet ? SIDEBAR_WIDTH_TABLET : SIDEBAR_WIDTH_DESKTOP;
  return (isOpen ? openWidth : 0) + ICON_RAIL_WIDTH;
};
